import apiUrls from '../urls';

export default function (api) {
    return {
        getFaq() {
            return api.get(apiUrls.FAQ);
        },
    }
};